"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = require("../requests/request");
const models_1 = require("../models");
var DeviceTokenProvider;
(function (DeviceTokenProvider) {
    DeviceTokenProvider["Apple"] = "apple";
    DeviceTokenProvider["Google"] = "google";
    DeviceTokenProvider["Web"] = "web";
})(DeviceTokenProvider = exports.DeviceTokenProvider || (exports.DeviceTokenProvider = {}));
class API {
    /**
     * Registers a new device with the provided data
     * @returns {Promise<User>} The Promise contains either a device or an APIError if rejected
     */
    static updateDevice(data, refresh_token) {
        let apiRequest = new request_1.BasicRequest('/devices/' + data.device_uuid, request_1.HTTPMethod.PUT, request_1.APIVersion.v1_2, undefined, data);
        apiRequest.refresh_token = refresh_token;
        return apiRequest.send(models_1.Device).then((data) => {
            return data.data;
        });
    }
    /**
     * Deletes the device
     * @param {string} uuid
     * @returns {Promise<void>} The Promise contains either an APIError if rejected
     */
    static deleteDevice(uuid) {
        let apiRequest = new request_1.AuthenticatedRequest('/devices/' + uuid, request_1.HTTPMethod.DELETE, request_1.APIVersion.v1_2);
        return apiRequest.send().then(() => {
            return void 0;
        });
    }
}
exports.API = API;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/endpoints/devices.js
// module id = 406
// module chunks = 0